<div
  [style.border-color]="appearance() === 'default' ? '#C4C4CF' : null"
  [attr.data-testid]="id()"
  [attr.aria-label]="text()"
  class="w-fit"
  [ngClass]="{
    'mb-3 rounded-lg border p-2 text-lg font-bold': appearance() === 'default',
    'inline-flex min-h-6 items-center gap-1 rounded-full px-2 py-0.5 text-sm leading-5 font-normal':
      appearance() !== 'default',
    'bg-standard-text-secondary/10 text-standard-text-primary':
      appearance() === 'neutral',
    'bg-warning-main/40 text-standard-text-primary': appearance() === 'warning',
    'bg-green-100 text-green-700': appearance() === 'success',
    'bg-red-100 text-red-800': appearance() === 'error',
  }">
  @if (icon(); as chipIcon) {
    <span
      class="material-symbols-rounded shrink-0 text-lg! leading-none"
      aria-hidden="true">
      {{ chipIcon }}
    </span>
  }
  <span>{{ text() }}</span>
</div>
